// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1bE5j","label":"Completed_label__3Bh1k"};